import React from 'react';
import PropTypes from 'prop-types';
import OperationsApprovalsHistory from 'components/operationsApprovals/OperationsApprovalsHistory';
import MissionsHistory from 'components/missionsApprovals/MissionsHistory';
import Filters from 'components/common/components/filters/Filtersv2';
import FilterDateTime from 'components/common/components/timePicker/FilterDateTime';

import { SidebarMenuDetailsUseStyles } from 'components/sidebar/SidebarMenuDetailsUseStyles';

const USpaceTable = props => {
  const { checkItem } = props;
  const classes = SidebarMenuDetailsUseStyles();
  const [filtersDataOperations, setFiltersDataOperations] = React.useState(
    null
  );
  const [filtersDataMissions, setFiltersDataMissions] = React.useState(null);
  const filtersType = [
    'status_operations',
    'status_missions',
    'icao',
    'aglmax',
  ];
  const dropdownOptionsToSpecifyKeyValuesToFilter = {
    status_operations: ['verify', 'landNow', 'rejected', 'accepted'],
    status_missions: ['verify', 'rejected', 'accepted'],
  };

  const [
    filtersDateTimeOperations,
    setFiltersDateTimeOperations,
  ] = React.useState(null);

  const [filtersDateTimeMissions, setFiltersDateTimeMissions] = React.useState(
    null
  );

  const [activeDetails, setActiveDetails] = React.useState(null);

  return (
    <div className={`${classes.SidebarMenuDetails}__table__details`}>
      <div className={`${classes.SidebarMenuDetails}__table__details__filters`}>
        <Filters
          filters={filtersType}
          setFiltersData={setFiltersDataOperations}
          setFiltersDataMissions={setFiltersDataMissions}
          dropdownOptionsToSpecifyKeyValuesToFilter={
            dropdownOptionsToSpecifyKeyValuesToFilter
          }
        />
      </div>

      {checkItem.operations ? (
        <OperationsApprovalsHistory
          filtersDataObject={filtersDataOperations}
          filtersDateTimeOperations={filtersDateTimeOperations}
          activeDetails={activeDetails}
          setActiveDetails={setActiveDetails}
          checkItem={checkItem}
        />
      ) : null}

      {checkItem.missions ? (
        <MissionsHistory
          filtersDataObject={filtersDataMissions}
          filtersDateTimeMissions={filtersDateTimeMissions}
          activeDetails={activeDetails}
          setActiveDetails={setActiveDetails}
          checkItem={checkItem}
        />
      ) : null}
      <div
        className={`${classes.SidebarMenuDetails}__table__details__timeline`}
      >
        <FilterDateTime
          setFiltersDateTime={setFiltersDateTimeOperations}
          setFiltersDateTimeMissions={setFiltersDateTimeMissions}
        />
      </div>
    </div>
  );
};

USpaceTable.propTypes = {
  checkItem: PropTypes.object,
};

export default USpaceTable;
